var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import throttle from 'lodash/throttle';
import { useCallback, useEffect, useState } from 'react';
import { useResizeObserver } from './useResizeObserver';
/** Returns width and height of the ref element.
 * Source: https://mantine.dev/hooks/use-element-size/ */
export function useElementSize() {
    var _a = useResizeObserver(), ref = _a[0], _b = _a[1], width = _b.width, height = _b.height;
    return { ref: ref, width: width, height: height };
}
/** Returns width and height of the ref element with throttling.
 * Explanation of throttle implementation: https://dmitripavlutin.com/react-throttle-debounce/  */
export function useElementSizeThrottled(timeoutInMs) {
    if (timeoutInMs === void 0) { timeoutInMs = 100; }
    var _a = useResizeObserver(), ref = _a[0], _b = _a[1], width = _b.width, height = _b.height;
    var _c = useState({ width: width, height: height }), throttledValues = _c[0], setThrottledValues = _c[1];
    var update = useCallback(throttle(setThrottledValues, timeoutInMs), [timeoutInMs]);
    // When width or height changes, call update function that is throttled.
    useEffect(function () {
        update({ width: width, height: height });
    }, [width, height]);
    // Stop the invocation of the debounced function after unmounting
    useEffect(function () {
        return function () {
            update.cancel();
        };
    }, []);
    return __assign({ ref: ref }, throttledValues);
}
